export default {
  name: "Wrapper"
};
